var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { attrs: { id: "my-container" } },
        [
          _c(
            "b-navbar",
            {
              attrs: {
                id: "header",
                type: "light",
                variant: "light",
                sticky: ""
              }
            },
            [
              _c("b-navbar-nav", [
                _c("h4", { staticClass: "mb-0" }, [_vm._v(_vm._s(_vm.title))])
              ]),
              _vm._v(" "),
              _c(
                "b-navbar-nav",
                { staticClass: "ml-auto" },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-input-group",
                            { attrs: { size: "sm" } },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "mr-1",
                                  attrs: {
                                    size: "sm",
                                    disabled:
                                      _vm.selected.length === 0 ||
                                      _vm.isBusyExport,
                                    variant: "info"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.exportTimesheetFile()
                                    }
                                  }
                                },
                                [
                                  _vm.isBusyExport
                                    ? _c("b-spinner", { attrs: { small: "" } })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-1",
                                    attrs: { icon: "table" }
                                  }),
                                  _vm._v(
                                    "\n                Скачать Табель\n              "
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("export-sidebar", {
                                attrs: {
                                  "sidebar-id": "sidebar-tasks-export",
                                  "storage-key": "sidebar_tasks_export",
                                  columns: _vm.exportableFields,
                                  "data-provider": _vm.provideExportData,
                                  "data-mapper": _vm.mapTaskForExport,
                                  "file-name": "Tasks.xlsx",
                                  "sheet-name": "Tasks",
                                  "is-busy": _vm.isBusy,
                                  "items-count": _vm.totalRows
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "extra-buttons",
                                    fn: function() {
                                      return [
                                        _c(
                                          "b-button",
                                          {
                                            staticClass: "ml-1",
                                            attrs: {
                                              size: "sm",
                                              variant: "warning"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.toggleTW()
                                              }
                                            }
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              staticClass: "mr-1",
                                              attrs: { icon: "info" }
                                            }),
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.isIncludeTW
                                                    ? "Скрыть детализацию"
                                                    : "Детализация"
                                                ) +
                                                "\n                  "
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _vm.visibleAdmins()
                                ? _c(
                                    "b-button",
                                    {
                                      staticClass: "mr-2",
                                      attrs: {
                                        size: "sm",
                                        disabled: _vm.isBusyExport,
                                        variant: "info"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.showImportModal()
                                        }
                                      }
                                    },
                                    [
                                      _vm.isBusyExport
                                        ? _c("b-spinner", {
                                            attrs: { small: "" }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("font-awesome-icon", {
                                        staticClass: "mr-1",
                                        attrs: { icon: "file-download" }
                                      }),
                                      _vm._v(
                                        "\n                Импорт\n              "
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "auto" } },
                        [
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle.sidebar-fields",
                                  modifiers: { "sidebar-fields": true }
                                }
                              ],
                              staticClass: "mr-2",
                              attrs: {
                                id: "table-settings",
                                size: "sm",
                                variant: "warning"
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: "cog" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-tooltip",
                            {
                              attrs: {
                                target: "table-settings",
                                triggers: "hover",
                                variant: "warning",
                                noninteractive: ""
                              }
                            },
                            [_vm._v("\n              Колонки\n            ")]
                          ),
                          _vm._v(" "),
                          _vm.canEditTasks()
                            ? _c(
                                "b-button",
                                {
                                  attrs: {
                                    size: "sm",
                                    variant: "success",
                                    disabled: _vm.isBusy
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.onCreate()
                                    }
                                  }
                                },
                                [
                                  _vm.isBusy
                                    ? _c("b-spinner", { attrs: { small: "" } })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-1",
                                    attrs: { icon: "plus" }
                                  }),
                                  _vm._v("\n              Новая\n            ")
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "filters-drawer",
            {
              attrs: {
                query: _vm.filters.query,
                "is-busy": _vm.isBusy,
                "filter-tags": _vm.activeFilterTags
              },
              on: {
                "update:query": function($event) {
                  return _vm.$set(_vm.filters, "query", $event)
                },
                "remove-tag": _vm.removeFilterTag,
                submit: _vm.onSearch,
                clear: _vm.onClearFilters
              }
            },
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("label", { staticClass: "small text-muted" }, [
                    _vm._v("Период")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "align-items-center" },
                    [
                      _c(
                        "b-col",
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "input-start-date",
                              size: "sm",
                              type: "date"
                            },
                            model: {
                              value: _vm.filters.start_date,
                              callback: function($$v) {
                                _vm.$set(_vm.filters, "start_date", $$v)
                              },
                              expression: "filters.start_date"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "px-2", attrs: { cols: "auto" } },
                        [_c("span", [_vm._v("—")])]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "input-end-date",
                              size: "sm",
                              type: "date"
                            },
                            model: {
                              value: _vm.filters.end_date,
                              callback: function($$v) {
                                _vm.$set(_vm.filters, "end_date", $$v)
                              },
                              expression: "filters.end_date"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "mt-1", attrs: { cols: "12" } },
                [
                  _c("label", { staticClass: "small text-muted" }, [
                    _vm._v("Объекты")
                  ]),
                  _vm._v(" "),
                  _c("location-multi-select", {
                    ref: "location_multi_select",
                    attrs: {
                      id: "location-multi-select",
                      "start-date": _vm.filters.start_date,
                      "end-date": _vm.filters.end_date,
                      "show-date-button": true
                    },
                    on: { onSelect: _vm.onSelectLocation }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.visibleAdmins()
                ? _c(
                    "b-col",
                    { staticClass: "mt-1", attrs: { cols: "12" } },
                    [
                      _c("label", { staticClass: "small text-muted" }, [
                        _vm._v("Сотрудники")
                      ]),
                      _vm._v(" "),
                      _c("user-multi-select", {
                        ref: "user_multi_select",
                        attrs: { id: "user-multi-select" },
                        on: { onSelect: _vm.onSelectUser }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "mt-1", attrs: { md: "6", cols: "12" } },
                [
                  _c("label", { staticClass: "small text-muted" }, [
                    _vm._v("Статус заявки")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form-select",
                    {
                      attrs: { id: "input-statuses", size: "sm" },
                      model: {
                        value: _vm.filters.status_id,
                        callback: function($$v) {
                          _vm.$set(_vm.filters, "status_id", $$v)
                        },
                        expression: "filters.status_id"
                      }
                    },
                    [
                      _c("option", { domProps: { value: 0 } }, [
                        _vm._v("Все статусы")
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.activeStatuses, function(option) {
                        return _c(
                          "option",
                          { key: option.id, domProps: { value: option.id } },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(option.name) +
                                "\n          "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "mt-1", attrs: { md: "6", cols: "12" } },
                [
                  _c("label", { staticClass: "small text-muted" }, [
                    _vm._v("Статус оплаты")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form-select",
                    {
                      attrs: { id: "input-paid-workers-statuses", size: "sm" },
                      model: {
                        value: _vm.filters.paid_workers,
                        callback: function($$v) {
                          _vm.$set(_vm.filters, "paid_workers", $$v)
                        },
                        expression: "filters.paid_workers"
                      }
                    },
                    [
                      _c("option", { domProps: { value: 0 } }, [
                        _vm._v("Все статусы оплаты")
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.activePaidWorkersStatuses, function(option) {
                        return _c(
                          "option",
                          { key: option.id, domProps: { value: option.id } },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(option.name) +
                                "\n          "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("b-table", {
            ref: "tasks",
            staticClass: "mb-0 text-small",
            style: _vm.tableStyle,
            attrs: {
              id: "tasks",
              "select-mode": "multi",
              selectedVariant: "success",
              striped: "",
              small: "",
              responsive: "",
              "show-empty": "",
              "empty-text": _vm.$t("message.common.emptyTable"),
              busy: _vm.isBusy,
              items: _vm.items,
              fields: _vm.renderedFields,
              "no-provider-filtering": "",
              "no-provider-paging": "",
              "no-provider-sorting": "",
              "no-local-sorting": "",
              "tbody-tr-class": _vm.tbodyRowClass,
              "sticky-header": "",
              "head-variant": "light"
            },
            on: {
              "sort-changed": _vm.sortChanged,
              "row-dblclicked": _vm.onRowClicked,
              "row-clicked": _vm.rowClicked
            },
            scopedSlots: _vm._u([
              {
                key: "table-busy",
                fn: function() {
                  return [
                    _c(
                      "div",
                      { staticClass: "text-center text-success my-2" },
                      [
                        _c("b-spinner", { staticClass: "align-middle" }),
                        _vm._v(" "),
                        _c("strong", [_vm._v("Загрузка")])
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              },
              {
                key: "head(selected)",
                fn: function(row) {
                  return [
                    _c("b-form-checkbox", {
                      staticClass: "mx-1",
                      attrs: {
                        indeterminate: _vm.indeterminate,
                        disabled: _vm.allSelectDisabled,
                        size: "md"
                      },
                      on: { change: _vm.selectAllRows },
                      model: {
                        value: _vm.allSelected,
                        callback: function($$v) {
                          _vm.allSelected = $$v
                        },
                        expression: "allSelected"
                      }
                    })
                  ]
                }
              },
              {
                key: "cell(selected)",
                fn: function(row) {
                  return [
                    row.item.selected
                      ? [
                          _c("span", { attrs: { "aria-hidden": "true" } }, [
                            _vm._v("✓")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "sr-only" }, [
                            _vm._v("Выбрана")
                          ])
                        ]
                      : [
                          _c("span", [_vm._v(" ")]),
                          _vm._v(" "),
                          _c("span", { staticClass: "sr-only" }, [
                            _vm._v("Не выбрана")
                          ])
                        ]
                  ]
                }
              },
              {
                key: "cell(action)",
                fn: function(row) {
                  return [
                    _c(
                      "b-dropdown",
                      {
                        attrs: { size: "sm", "no-caret": "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "button-content",
                              fn: function() {
                                return [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: ["fas", "ellipsis-v"] }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        )
                      },
                      [
                        _vm._v(" "),
                        _c(
                          "b-dropdown-item-button",
                          {
                            attrs: { variant: "success", target: "_blank" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.onRead(row.item)
                              }
                            }
                          },
                          [
                            _c("font-awesome-icon", { attrs: { icon: "eye" } }),
                            _vm._v("\n            Смотреть\n          ")
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.isVisibleReadOnlyForRow(row.item)
                          ? _c(
                              "b-dropdown-item-button",
                              {
                                attrs: { variant: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.onEdit(row.item)
                                  }
                                }
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: "edit" }
                                }),
                                _vm._v(
                                  "\n            Редактировать\n          "
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "b-dropdown-item-button",
                          {
                            attrs: { variant: "warning" },
                            on: {
                              click: function($event) {
                                return _vm.onCopy(row.item)
                              }
                            }
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: "copy" }
                            }),
                            _vm._v("\n            Копировать\n          ")
                          ],
                          1
                        ),
                        _vm._v(" "),
                        row.item.invoice_numb
                          ? _c(
                              "b-dropdown-item-button",
                              {
                                attrs: { variant: "info" },
                                on: {
                                  click: function($event) {
                                    return _vm.onInvoiceFile(row.item)
                                  }
                                }
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: "copy" }
                                }),
                                _vm._v("\n            Скачать счёт\n          ")
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isVisibleReadOnlyForRow(row.item)
                          ? _c(
                              "b-dropdown-item-button",
                              {
                                attrs: { variant: "danger" },
                                on: {
                                  click: function($event) {
                                    return _vm.onRemove(row)
                                  }
                                }
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: ["fas", "trash"] }
                                }),
                                _vm._v("\n            Удалить\n          ")
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                }
              },
              {
                key: "cell(location_name)",
                fn: function(row) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(row.item.location_name) +
                        "\n        "
                    ),
                    _c(
                      "p",
                      { staticClass: "m-0 p-0 text-secondary text-small" },
                      [_vm._v(_vm._s(row.item.customer_name))]
                    )
                  ]
                }
              },
              {
                key: "cell(payment_type_int)",
                fn: function(row) {
                  return [
                    _c("font-awesome-icon", {
                      attrs: {
                        set: (_vm.pt = _vm.paymentTypeIcon(
                          row.item.payment_type_int
                        )),
                        icon: ["fas", _vm.pt.icon],
                        title: _vm.pt.title
                      }
                    })
                  ]
                }
              },
              {
                key: "cell(start_date)",
                fn: function(row) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.formatTableDateTime(row.item.start_date)) +
                        "\n      "
                    )
                  ]
                }
              },
              {
                key: "cell(task_workers)",
                fn: function(row) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.len(row.item.task_workers)) +
                        "\n      "
                    )
                  ]
                }
              },
              {
                key: "cell(paid_workers)",
                fn: function(row) {
                  return [
                    _c("font-awesome-icon", {
                      style: _vm.paidWorkers(row).style,
                      attrs: { icon: ["fas", _vm.paidWorkers(row).icon] }
                    })
                  ]
                }
              },
              {
                key: "cell(status_id)",
                fn: function(row) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-between align-items-center"
                      },
                      [
                        _c(
                          "span",
                          { staticStyle: { "font-size": "medium" } },
                          [
                            _c(
                              "b-badge",
                              {
                                attrs: {
                                  pill: "",
                                  variant: _vm.getStatusStyle(
                                    row.item.status_id
                                  )
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.getStatusName(row.item.status_id)
                                    ) +
                                    "\n            "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          [
                            _c("font-awesome-icon", {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover.top",
                                  modifiers: { hover: true, top: true }
                                }
                              ],
                              style: _vm.paidWorkers(row).style,
                              attrs: {
                                icon: ["fas", _vm.paidWorkers(row).icon],
                                title: "Оплата исполнителям"
                              }
                            }),
                            _vm._v(" "),
                            _c("font-awesome-icon", {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover.top",
                                  modifiers: { hover: true, top: true }
                                }
                              ],
                              style: _vm.readOnly(row).style,
                              attrs: {
                                icon: ["fas", _vm.readOnly(row).icon],
                                title: "Редактирование заявки"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ]
                }
              },
              {
                key: "cell(invoice_numb)",
                fn: function(row) {
                  return [
                    _vm.visibleAdmins() && row.item.invoice_numb
                      ? _c(
                          "b-button",
                          {
                            attrs: { size: "sm", variant: "link" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.showInvoice(row.item)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(row.item.invoice_numb) +
                                "\n        "
                            )
                          ]
                        )
                      : _c("div", [
                          _vm._v(
                            "\n          " +
                              _vm._s(row.item.invoice_numb) +
                              "\n        "
                          )
                        ])
                  ]
                }
              },
              {
                key: "cell(executor_name)",
                fn: function(row) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(row.item.executor_name) +
                        "\n        "
                    ),
                    _c("p", { staticClass: "m-0 p-0 text-small" }, [
                      _vm._v(_vm._s(row.item.total_manager) + " ₽")
                    ])
                  ]
                }
              },
              {
                key: "cell(location_rate)",
                fn: function(row) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(row.item.payment_first) +
                        " ₽\n        "
                    ),
                    _c("p", { staticClass: "m-0 p-0 text-small" }, [
                      _vm._v(_vm._s(_vm.getUnit(row.item.unit_code)))
                    ])
                  ]
                }
              },
              {
                key: "cell(read_only)",
                fn: function(row) {
                  return [
                    _c("font-awesome-icon", {
                      style: _vm.readOnly(row).style,
                      attrs: { icon: ["fas", _vm.readOnly(row).icon] }
                    })
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("pagination-footer", {
            attrs: { "total-rows": _vm.totalRows, "per-page": _vm.perPage },
            on: {
              "update:perPage": function($event) {
                _vm.perPage = $event
              },
              "update:per-page": function($event) {
                _vm.perPage = $event
              },
              "page-click": _vm.onPagination,
              "per-page-change": _vm.onPerPageChange
            },
            scopedSlots: _vm._u([
              {
                key: "footer-update",
                fn: function() {
                  return [
                    _vm.selected.length > 0
                      ? _c(
                          "b-row",
                          {
                            attrs: { "align-h": "between", "align-v": "center" }
                          },
                          [
                            _c(
                              "b-col",
                              {
                                staticClass: "mr-auto text-small",
                                attrs: { cols: "auto" }
                              },
                              [
                                _vm._v("\n            Выбрано: "),
                                _c("b", [_vm._v(_vm._s(_vm.selected.length))]),
                                _vm._v("\n            | С заказчика: "),
                                _c("b", [
                                  _vm._v(_vm._s(_vm.totalSelectedPrice))
                                ]),
                                _vm._v("\n            | Кол-во исп: "),
                                _c("b", [
                                  _vm._v(_vm._s(_vm.totalSelectedWorkers))
                                ]),
                                _vm._v("\n            | Кол-во: "),
                                _c("b", [
                                  _vm._v(_vm._s(_vm.totalSelectedUnits))
                                ]),
                                _vm._v("\n            | Исполнителям: "),
                                _c("b", [
                                  _vm._v(_vm._s(_vm.totalSelectedWorkerPrice))
                                ]),
                                _vm._v("\n            | Менеджеру: "),
                                _c("b", [
                                  _vm._v(_vm._s(_vm.totalSelectedManager))
                                ]),
                                _vm._v("\n            | Руководителю: "),
                                _c("b", [
                                  _vm._v(_vm._s(_vm.totalSelectedProject))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "auto" } },
                              [
                                _vm.visibleAdmins()
                                  ? _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          size: "sm",
                                          variant: "info",
                                          disabled:
                                            !_vm.allStatusesEqual ||
                                            _vm.newStatusDisabled
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.onNewStatus()
                                          }
                                        }
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          staticClass: "mr-1",
                                          attrs: { icon: "undo" }
                                        }),
                                        _vm._v(
                                          "\n              На доработку\n            "
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      size: "sm",
                                      variant: "info",
                                      disabled:
                                        !_vm.allStatusesEqual ||
                                        _vm.payStatusDisabled
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.onPayStatus()
                                      }
                                    }
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "mr-1",
                                      attrs: { icon: "cash-register" }
                                    }),
                                    _vm._v(
                                      "\n              На оплату\n            "
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.visibleAdmins()
                                  ? _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          size: "sm",
                                          variant: "warning",
                                          disabled: _vm.payWorkersDisabled
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.onPayWorkers()
                                          }
                                        }
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          staticClass: "mr-1",
                                          attrs: { icon: "receipt" }
                                        }),
                                        _vm._v(
                                          "\n              Оплатить исполнителям\n            "
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.visibleAdmins()
                                  ? _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          size: "sm",
                                          variant: "info",
                                          disabled:
                                            !_vm.allStatusesEqual ||
                                            _vm.invoiceDisabled
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.onInvoice()
                                          }
                                        }
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          staticClass: "mr-1",
                                          attrs: { icon: "file-invoice-dollar" }
                                        }),
                                        _vm._v(
                                          "\n              Выставить счёт\n            "
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selected.length > 0 ? _c("hr") : _vm._e()
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("tasks-import", {
        ref: "tasks_import",
        on: { refresh: _vm.handleTasksImport }
      }),
      _vm._v(" "),
      _c("dynamic-tables", {
        attrs: {
          "storage-key": "tasks_columns",
          "sidebar-fields": "sidebar-fields",
          "fields-model": _vm.fields,
          fieldKey: "id"
        },
        on: {
          "update:fieldsModel": function($event) {
            _vm.fields = $event
          },
          "update:fields-model": function($event) {
            _vm.fields = $event
          }
        }
      }),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalSelectPayOrganization",
          attrs: {
            id: "modal-select-pay-organization",
            title: "Организация",
            "ok-title": "Оплатить",
            "button-size": "sm",
            "ok-disabled": this.currentPayOrganization == null,
            "cancel-title": _vm.$t("message.actions.cancel")
          },
          on: {
            ok: function($event) {
              return _vm.onPay()
            }
          }
        },
        [
          _c("organization-select", {
            ref: "organization_select",
            attrs: { id: "input-org-select", "initial-id": 0 },
            on: { onSelect: _vm.onSelectOrg }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b61eda6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b61eda6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tasks/Tasks.vue
// module id = null
// module chunks = 